import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';
import RectificationProgressView from './RectificationProgressView';
import Spinner from '@/presentation/components/Spinner';
import routes from '@/presentation/components/Routes/routingMap';

const RectificationProgressViewController = () => {
  const history = useHistory();
  const { procedure, request } = useSelector(
    (state: any) => state.procedureStudentStatus
  );

  const handlerBackButton = () => {
    history.push('/tramites');
  };

  useEffect(() => {
    if (request?.status?.name === 'Procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.rectificationOfNotes
            .progress
        }${'?status=finalizado'}`
      );
    }

    if (request?.status?.name === 'No procede') {
      history.push(
        `${
          routes.student.procedures.categories.requests.rectificationOfNotes
            .progress
        }${'?status=Finalizadonoprocede'}`
      );
    }
  }, [request]);

  if (!procedure) {
    return <Spinner />;
  }

  return (
    <RectificationProgressView
      procedure={procedure}
      request={request}
      handlerBackButton={handlerBackButton}
      isComplete={['NO_PROCEDE', 'PROCEDE'].includes(request.status.status)}
    />
  );
};

export default RectificationProgressViewController;
